/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {TheBorderGameMode} from "../server/TheBorderGameMode";
import {IWinRatioConfig, TheBorderWinConfigs} from "../configs/TheBorderWinConfigs";
import {LoopableList} from "../utils/LoopableList";
import {gsap} from "gsap";
import {IFadeTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class TheBorderSound {

    public static REELS_LANDING: LoopableList<string> = new LoopableList(
        ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6"
        ]).setRandomizeAtWrapAround(true);
    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static FS_INTRO_MUSIC_NAME: string = "fsIntro";
    public static SUPER_FS_INTRO_MUSIC_NAME: string = "fsIntro";

    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";

    public static COUNT_UP: string = "countup";
    public static CAP_WIN_COUNT_UP: string = "capwinCountup";
    public static CAP_WIN_LOOP: string = "capwinLoop";
    public static CAP_WIN_CONTINUE: string = "capWinContinue";
    public static COUNT_UP_END_TINY: string = "countupEndTiny";
    public static COUNT_UP_END_SMALL: string = "countupEndSmall";
    public static COUNT_UP_END_MEDIUM: string = "countupEndMid";
    public static COUNT_UP_END_LARGE: string = "countupEndLarge";
    public static WIN_FRAMES_EXPLODE: LoopableList<string> = new LoopableList(["winFramesExplode01", "winFramesExplode02", "winFramesExplode03"]).setRandomizeAtWrapAround(true);
    public static WIN_FRAMES_EXPLODE_ABORT: LoopableList<string> = new LoopableList(["winFramesExplodeAbort01", "winFramesExplodeAbort02", "winFramesExplodeAbort03"]).setRandomizeAtWrapAround(true);
    public static SPIN_ALL_OUT: string = "reelsOut";
    public static SPIN_ALL_IN: string = "reelsIn";
    public static BIG_WIN_EFFECTS: string[] = ["bigwinInit", "bigwin1", "bigwin2", "bigwin3", "bigwin4", "bigwin5"];
    public static BIG_WIN_END: string = "bigwinEnd";
    public static FS_END: string = "fsEnd";
    public static FS_OUTRO: string = "fsOutro";
    public static FS_OUTRO_NO_WIN: string = "fsOutroNoWin";
    public static BOOSTER_ON: string = "boosterOn";
    public static BOOSTER_OFF: string = "boosterOff";
    public static X_RIP_POOF:string = "countupEndXrip";
    public static X_RIP_FLASH:string = "xripFlash";
    public static BIG_WIN_MUSICS: string[] = ["bigwinMusicInit", "bigwinMusic1", "bigwinMusic2", "bigwinMusic3", "bigwinMusic4", "bigwinMusic5"];
    public static BIG_WIN_MUSIC_END: string = "bigwinMusicEnd";
    private static FS_MUSIC_NAME: string = "fs";
    private static SFS_MUSIC_NAME: string = "sfs";
    private static davidPanningReelStop: number[] = [-0.35, -0.25, -0.18, 0.01, 0.18, 0.25, 0.35];
    public static FS_CONTINUE_START: string = "fsContinueStart";
    public static FS_CONTINUE_END: string = "fsContinueEnd";
    public static FS_SWEEP: string = "fsSweep";
    public static SPLIT_LAND: string = "splitLand";
    public static BOMB_LAND: string = "bombLand";
    public static NUDGE_LAND: string = "nudgeLand";
    public static WAYS_LAND: string = "waysLand";
    public static BOMB_EXPLODE: string = "bombExplode";
    public static WAYS_REVEAL: string = "waysReveal";
    public static MULTIPLIER_UP_SOUNDS: string[] = ["multiplierUp01", "multiplierUp02", "multiplierUp03"];
    public static SPLIT_SOUNDS: string[] = ["splitCut01", "splitCut02", "splitCut03"];
    public static NUDGE_SYMBOL_SOUNDS: string[] = ["nudgeSymbol01", "nudgeSymbol02", "nudgeSymbol03"];
    public static MULTIPLIER_SWOSH_SOUNDS: string[] = ["multiplierSwosh01", "multiplierSwosh02", "multiplierSwosh03"];
    public static NUDGE_SOUND: string = "nudge";
    public static WAYS_SOUNDS: string[] = ["waysExpand01", "waysExpand02", "waysExpand03"];
    public static SPLIT_SYMBOL_SOUNDS: string[] = ["splitCutSymbol01", "splitCutSymbol02", "splitCutSymbol03", "splitCutSymbol04", "splitCutSymbol05"];
    private static SPLIT_SYMBOL_PANNING: number[] = [-0.25, -0.18, 0.01, 0.18, 0.25];
    public static FS_END_STATUE_EXPLODE: string = "fsEndStatueExplode";
    public static SCATTER_LAND_SOUNDS: string[] = ["scatter1Land", "scatter2Land", "scatter3Land", "scatter4Land"];
    public static SCATTER_LAND_SOUND_X_RIP: string = "scatter1LandxRip";
    public static SCATTER_ADDITIONAL: string = "scatterAdditional";
    public static SCATTER_ANTICIPATION: string = "scatterAnticipation";
    public static SCATTER_UNLOCK_FS: string = "scatterUnlockFS";
    public static SCATTER_UNLOCK_SFS: string = "scatterUnlockSFS";
    public static SCATTER_UNLOCK_BOUNCE: string = "scatterUnlockBounce";
    public static SCATTER_UNLOCK_FAIL: string = "scatterUnlockFail";
    public static BOOSTER_IDLE_SPARKS: LoopableList<string> = new LoopableList(["boosterIdlesparks01", "boosterIdlesparks02", "boosterIdlesparks03"]).setRandomizeAtWrapAround(true);

    private _currentMusic: string;
    private _countUpSound: NolimitHowl | undefined;
    private player: NolimitAudioPlayer;

    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound;
    }

    public playSound(name: string, volume?: number, repeat?: number): NolimitHowl | undefined {
        Logger.logDev("------- Play sound: " + name);
        return this.player.playTrack({name: name, volume: volume, repeat: repeat});
    }

    public stopSound(name: string): NolimitHowl | undefined {
        return this.player.stopTrack(name);
    }

    // Use this to handle the music(sounds that are in loops folder), eg, fade out/in music in big win, and you don't need to care what music is playing
    public fadeMusic(fadeConfig: IFadeTrackConf): void {
        const fadeName: string = fadeConfig.name ? fadeConfig.name : this._currentMusic;
        fadeConfig.name = fadeName;
        this.player.fadeTrack(fadeConfig);

        Logger.logDev("------- fading sound " + fadeName + " in " + fadeConfig.duration + " ms, volume to " + fadeConfig.to);
    }

    // Use this to handle the music(sounds that are in loops folder), eg, fade out/in music in big win, and you don't need to care what music is playing
    public fadeCurrentMusicAndResetCurrentMusic(fadeConfig: IFadeTrackConf): void {
        const fadeName: string = this._currentMusic;
        fadeConfig.name = fadeName;
        this.player.fadeTrack(fadeConfig);
        this._currentMusic = "";
        Logger.logDev("------- fading sound and resetting currentMusic " + fadeName + " in " + fadeConfig.duration + " ms, volume to " + fadeConfig.to);
    }

    // Use this to fade out sounds that are in effects folder
    public fadeOutEffect(fadeOutConf: IFadeTrackConf): void {
        const fade: NolimitHowl | undefined = this.player.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000, onComplete: () => {
                    this.player.stopTrack(fadeOutConf.name);
                }
            });
        } else {
            this.player.stopTrack(fadeOutConf.name);
        }
    }

    public playNonLoopSound(name: string): void {
        Logger.logDev("------- Play non loop sound: " + name);
        this.player.playTrack({name: name})?.setLoop(false);
    }

    public switchMusic(mode: TheBorderGameMode, fadeOutConf?: IFadeTrackConf, fadeInConf?: IFadeTrackConf): void {
        let nextMusic;
        switch (mode) {
            case TheBorderSound.FS_INTRO_MUSIC_NAME:
                nextMusic = TheBorderSound.FS_INTRO_MUSIC_NAME;
                break;
            case TheBorderGameMode.FREESPIN:
            case TheBorderGameMode.FREESPIN_AVALANCHE:
                nextMusic = TheBorderSound.FS_MUSIC_NAME;
                break;
            case TheBorderGameMode.SUPER_FREESPIN: //#251
            case TheBorderGameMode.SUPER_FREESPIN_AVALANCHE:
                nextMusic = TheBorderSound.SFS_MUSIC_NAME;
                break;
            case TheBorderGameMode.NORMAL_AVALANCHE:
                nextMusic = TheBorderSound.MAIN_GAME_MUSIC;
                break;
            case TheBorderSound.FS_OUTRO_NO_WIN:
                nextMusic = TheBorderSound.FS_OUTRO_NO_WIN;
                break;
            case TheBorderSound.FS_OUTRO:
                nextMusic = TheBorderSound.FS_OUTRO;
                break;
            default:
                nextMusic = TheBorderSound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic !== null) {
            const fadeName: string = this._currentMusic;
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade: NolimitHowl | undefined = this.player.fadeTrack(fadeOutConf);
                if (fade) {
                    gsap.to(this, {
                        duration: fadeOutConf.duration / 1000, onComplete: () => {
                            this.player.stopTrack(fadeName);
                        }
                    });
                } else {
                    this.player.stopTrack(fadeName);
                }
            } else {
                this.player.stopTrack(fadeName);
            }
        }

        Logger.logDev("------- Switching sound from: " + this._currentMusic + " to: " + nextMusic);

        this.player.playTrack({name: nextMusic, volume: 1});
        if (fadeInConf) {
            fadeInConf.name = nextMusic;
            this.player.fadeTrack(fadeInConf);
        }
        this._currentMusic = nextMusic;
    }

    public playRandomReelStopSound(reelId: number): void {
        const soundName: string = TheBorderSound.REELS_LANDING.next();
        const sound: NolimitHowl | undefined = this.playSound(soundName);
        if (sound) {
            sound.player.stereo(TheBorderSound.davidPanningReelStop[reelId]);
        }
    }

    public playSplitPanningSound(): void {
        const soundIndex: number = Math.floor(Math.random() * TheBorderSound.SPLIT_SYMBOL_SOUNDS.length);
        const sound: NolimitHowl | undefined = this.playSound(TheBorderSound.SPLIT_SYMBOL_SOUNDS[soundIndex]);
        if (sound) {
            sound.player.stereo(TheBorderSound.SPLIT_SYMBOL_PANNING[soundIndex]);
        }
    }

    public startCountUp() {
        this._countUpSound = this.playSound(TheBorderSound.COUNT_UP);
        if (this._countUpSound) {
            this._countUpSound.setLoop(true);
        }
    }

    public stopCountUp(config?: IWinRatioConfig, playEndSound: boolean = true) {
        if (this._countUpSound && this._countUpSound.isPlaying) {
            this._countUpSound.stop();
        }

        if (playEndSound) {
            let sound = TheBorderSound.COUNT_UP_END_LARGE;

            if (config) {
                if (config.type == TheBorderWinConfigs.TINY) {
                    sound = TheBorderSound.COUNT_UP_END_TINY;
                } else if (config.type == TheBorderWinConfigs.SMALL) {
                    sound = TheBorderSound.COUNT_UP_END_SMALL;
                } else if (config.type == TheBorderWinConfigs.MEDIUM) {
                    sound = TheBorderSound.COUNT_UP_END_MEDIUM;
                } else if (config.type == TheBorderWinConfigs.BIG_WIN_06) {
                    sound = "";
                }
            }

            this.playSound(sound);
        }
    }

    public playXSplitSymbolCutSound(): void {
        this.playSplitPanningSound();
    }
}